export default {"src":"/frontend-static/_next/static/media/coupon.ce55bd75.svg","height":26,"width":30,"blurWidth":0,"blurHeight":0};